import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';

import { connect, Dispatch } from 'react-redux';
import { IEventMonth, ICalendarState, RawActions } from '@adage/ace-calendar';
import { create } from '@adage/calendar';

import { IWACEvent, ICalendarReduxState, transitionWidthPx } from '../classes';

import DesktopContainer from './desktop-container';
import MobileContainer from './mobile-container';

import Filters from '../containers/filters';
import MobileFilters from '../containers/filters-mobile';
import Loader from '../components/loader';

import { MediaQueryProps } from 'react-responsive';
import { ICalendar } from "@adage/calendar/services/calendar";
import { addImagesToLoad } from "../redux/actions/index";
import { isElementVisible } from "../helpers/index";
import { setLastDateToDisplay } from '../redux/actions/calendar-mode-actions';

var MediaQuery: React.ComponentClass<MediaQueryProps> = require('react-responsive');

interface CalendarExternalProps {
    monthsToDisplay: number;
}

interface CalendarStateFromProps {
    evts: Array<IEventMonth<IWACEvent>>;
    isGrid: boolean;
}

interface DispatchToProps {
    goToMonth: (month: moment.Moment) => any;
    setLastMonthToDisplay: () => any;
}

type CalendarProps = CalendarStateFromProps & CalendarExternalProps & DispatchToProps;

interface CalendarState {
    calendarMonths: Array<ICalendar<IWACEvent>>;
    allMonths: Array<moment.Moment>;
    loadMore: boolean;
}

class CalendarApp extends React.Component<CalendarProps, CalendarState> {
    /**
     * Lifecycle functions.
     * @param props
     */
    constructor(props: CalendarProps) {
        super(props);

        props.setLastMonthToDisplay();

        this.state = {
            calendarMonths: this.createCalendarFromEvents(props.evts),
            allMonths: props.evts.map(evtMonth => evtMonth.monthMoment),
            loadMore: true
        };
    }

    componentWillReceiveProps(props: CalendarProps) {

        this.setState({
            calendarMonths: this.createCalendarFromEvents(props.evts),
            allMonths: props.evts.map(evtMonth => evtMonth.monthMoment),
            loadMore: props.evts.length < props.monthsToDisplay
        })
    }

    /**
     * Helper functions.
     */
    private createCalendarFromEvents(evts: Array<IEventMonth<IWACEvent>>) {
        const today = moment().clone().startOf("day");

        for (let evtMonth of evts) {
            // Skip if it's a month in the future.
            if (evtMonth.monthMoment.clone().startOf("month").isSame(moment().startOf("month")))
                break;

            evtMonth.events = evtMonth.events.filter(event => {
                const eventDate = moment(event.eventDate).startOf("day");

                return eventDate.isAfter(today);
            });
        }

        return evts.map(eventMonth => create({
            events: eventMonth.events,
            month: eventMonth.monthMoment.month(),
            year: eventMonth.monthMoment.year(),
            weekdayNames: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
        }));
    }
    /**
     * Render function.
     */
    render() {
        return (
            <div>

                <MediaQuery query={`(min-width: ${transitionWidthPx}px)`}>
                    <Filters />
                    <DesktopContainer allMonths={this.state.allMonths} calendarMonths={this.state.calendarMonths} evts={this.props.evts} />
                </MediaQuery>

                <MediaQuery query={`(max-width: ${transitionWidthPx}px)`}>
                    <MobileFilters />
                    <MobileContainer allMonths={this.state.allMonths} calendarMonths={this.state.calendarMonths} evts={this.props.evts} />
                </MediaQuery>
                {
                    this.state.loadMore ? <Loader /> : null
                }
            </div>
        )
    }
}

function mapStateToProps(state: ICalendarReduxState, externalProps: CalendarExternalProps) {
    return {
        evts: state.calendarModel.events,
        isGrid: state.calendarModeModel.isGrid
    }
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>, ownProps: CalendarExternalProps): DispatchToProps {
    return {
        goToMonth: (month: moment.Moment) => dispatch(RawActions.goToMonth(month)),
        setLastMonthToDisplay: () => dispatch(setLastDateToDisplay(ownProps.monthsToDisplay))
    }
}

export default connect<CalendarStateFromProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(CalendarApp);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/containers/app.tsx